export const companyFeedback = {
  data () {
    return {
      form: {
        feedback: "",
      }
    }
  }
}